export default function getCurrentDate() {
  return new Date();
}